import { Check } from "@mui/icons-material";
import type { TPeriod } from "store/periodStore";

import StatusPill from "./StatusPill";
import { formatDates } from "./utils";

interface PeriodDropdownItemProps {
    period: TPeriod;
    isSelected: boolean;
    t: (key: string) => string;
    onSelect: (id: number) => void;
}

const PeriodDropdownItem = ({ period, isSelected, t, onSelect }: PeriodDropdownItemProps) => (
    <button
        type="button"
        onClick={() => onSelect(period.id)}
        className={`period-dropdown__item ${isSelected ? "period-dropdown__item--selected" : ""}`}
    >
        <div className="period-dropdown__radio">
            {isSelected && <Check sx={{ fontSize: "0.75rem", color: "#333", strokeWidth: 2, stroke: "#333" }} />}
        </div>

        <div className="period-dropdown__item-content">
            <span className={`period-dropdown__item-date ${isSelected ? "period-dropdown__item-date--selected" : ""}`}>
                {formatDates(period)}
            </span>
            <div className="period-dropdown__item-right">
                <span className="period-dropdown__item-duration">
                    {period.periodDuration} {t("ConnectTitle.PeriodTypeMonth")}
                </span>
                <StatusPill status={period.isActive} compact t={t} />
            </div>
        </div>
    </button>
);

export default PeriodDropdownItem;
